// extracted by mini-css-extract-plugin
export default {"suggestions":"Suggestions-module__suggestions--xx7xE","suggestionButton":"Suggestions-module__suggestionButton--m62lD"};